import { receptionSave } from '@/api'
import { failMsg, debounce } from '@/libs/utils'
import Cookies from 'js-cookie'
const state = {
    orderSourceId: Cookies.get('orderSourceId') ? Cookies.get('orderSourceId') : {},
}

const debouncedVisitsNum = debounce(async (context, dispatch) => {
    try {
        let res = await receptionSave(context)
        if (res.result) {
            window.open(context.receptionUrl)
        } else {
            failMsg(res.msg)
        }
    } catch (error) {
        failMsg(error)
        return Promise.reject()
    }
}, 300);

const debouncedVisitsNumWechat = debounce(async (context, dispatch) => {
    try {
        let res = await receptionSave(context)
        if (!res.result) {
            failMsg(res.msg)
        }
    } catch (error) {
        failMsg(error)
        return Promise.reject()
    }
}, 300);

const actions = {
    visitsNum({ commit }, context) {
        return debouncedVisitsNum(context, this.dispatch);
    },
    visitsNumWechat({ commit }, context) {
        return debouncedVisitsNumWechat(context, this.dispatch);
    },
}

const mutations = {
    getOrderSourceId(state, params) {
        state.orderSourceId = params
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}
